import { TREE_VIEW } from '../resources';

export const CrmSourcesSelector = state => state[TREE_VIEW].crmSources;
export const CrmDefaultsSelector = state => state[TREE_VIEW].crmDefaults;
export const CrmDefaultBoardsSelector = state => state[TREE_VIEW].boards;
export const CrmBoardStatusesSelector = state => state[TREE_VIEW].statuses;
export const CrmDefaultCompaniesSelector = state => state[TREE_VIEW].companies;
export default {};
